import EmptyState from "../UI/EmptyState";
import FraseRow from "./FraseRow";

const FrasesTable = ({ frases, search }) => {
  if (!frases || frases.length === 0) {
    return (
      <EmptyState
        icon={search ? "mdi:magnify-remove-outline" : "mdi:format-quote-close"}
        title={
          search ? "No se encontraron frases" : "No hay frases para mostrar"
        }
        description={search ? "Intenta con otra búsqueda" : null}
      />
    );
  }

  return (
    <div className="table-responsive scroll-sm">
      <table
        className="table bordered-table mb-0"
        style={{ minWidth: "1000px" }}
      >
        <thead>
          <tr>
            <th scope="col" style={{ minWidth: "300px" }}>
              Frase
            </th>
            <th scope="col" style={{ minWidth: "150px" }}>
              Talento
            </th>
            <th scope="col" style={{ minWidth: "120px" }}>
              Tipo
            </th>
            <th scope="col" style={{ minWidth: "100px" }}>
              Estatus
            </th>
            <th scope="col" style={{ minWidth: "80px" }}>
              Acciones
            </th>
          </tr>
        </thead>
        <tbody>
          {frases.map((frase) => (
            <FraseRow key={frase.id} frase={frase} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FrasesTable;
